// extracted by mini-css-extract-plugin
export default {"arrow_container":"LimitCurrencyConverter_arrow_container__Zw7Gh","arrow":"LimitCurrencyConverter_arrow__fK9hF","times_icon":"LimitCurrencyConverter_times_icon__Ong7j"};